import { render, staticRenderFns } from "./category-delivery-select.vue?vue&type=template&id=266d3ccc"
import script from "./category-delivery-select.vue?vue&type=script&lang=js"
export * from "./category-delivery-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports